import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-4 border-oro bg-noche-dark pb-16" data-id="element-73" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-74" data-mp="32nukakr5twzs">
        <p className="text-xs leading-snug text-white" data-id="element-75" data-mp="32pp764lzrz6i">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[11px] leading-snug text-white/70" data-id="element-76" data-mp="36n3chl6jxmt8">
          {PRODUCT_NAME} es un producto educativo. No sustituye formación
          académica oficial, capacitación profesional, práctica supervisada,
          normas de seguridad de laboratorio, certificaciones ni el criterio de
          profesionales habilitados. Toda actividad experimental debe
          realizarse con materiales apropiados, evaluación de riesgos y
          supervisión correspondiente.
        </p>
        <p className="mt-1.5 text-xs text-white" data-id="element-77" data-mp="2a19vns22jyzx">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-oro transition-colors duration-150 ease-out hover:text-white" data-id="element-78" data-mp="2ezuupo5l4cms">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-white" data-id="element-79" data-mp="3gcjw6rxsy2hf">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-oro" data-id="element-80" data-mp="3q725cclzmq8m">
            Términos y Condiciones
          </a>
          <span className="text-oro" aria-hidden="true" data-id="element-81" data-mp="32w3duq73ebb">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-oro" data-id="element-82" data-mp="hsk3ismn46xg">
            Política de Privacidad
          </a>
          <span className="text-oro" aria-hidden="true" data-id="element-83" data-mp="cw34v4htea64">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-oro" data-id="element-84" data-mp="qu1gi24r3shx">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}